import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import './Home.css';
import { useCountry } from '../contexts/CountryContext';
import config from '../config'; // Adjust the import path as necessary
// Fallback flag emojis in case images don't load
const countryFlags = {
  TH: "🇹🇭",
  SG: "🇸🇬",
  MY: "🇲🇾",
  VN: "🇻🇳",
  ID: "🇮🇩",
  PH: "🇵🇭"
};

const Home = ({ onProjectSelect, onNavigation }) => {
  const { selectedCountry, updateCountry, globalFilter, setGlobalFilter, projectno, setProjectno } = useCountry();
  const [uploading, setUploading] = useState({});
  const [uploadStatus, setUploadStatus] = useState({});
  const [selectedFiles, setSelectedFiles] = useState({});
  const [username, setUsername] = useState(null);
  useEffect(() => {
    // This code runs once after the component mounts
    const storedUsername = localStorage.getItem('username');
    if (storedUsername) {
      setUsername(storedUsername);
    }
  }, []); // The empty array ensures this effect runs only once

  useEffect(() => {
    setGlobalFilter('Brand Funnel');
  }, []);

  const PROJECTS = [
    {
      id: 1,
      name: "Grab Food",
      description: "Food delivery service analytics",
      countries: ["TH", "SG", "MY", "VN", "ID", "PH"]
    },
    {
      id: 2,
      name: "Grab Eco",
      description: "Ride-hailing service analytics",
      countries: ["TH", "SG", "MY", "VN", "ID", "PH"]
    },
    // {
    //   id: 3,
    //   name: "Grab Express",
    //   description: "Package delivery analytics",
    //   countries: ["TH", "SG", "MY"]
    // },
    // {
    //   id: 4,
    //   name: "GrabMart",
    //   description: "Quick commerce analytics",
    //   countries: ["TH", "SG", "MY", "VN"]
    // }
  ];

  // Country images
  const countryImages = {
    TH: "https://cdn.countryflags.com/thumbs/thailand/flag-3d-round-250.png",
    SG: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQz4wyetjtaMbjldxGLB7wwJBR0NAHJzmKDdQ&s",
    MY: "https://media.istockphoto.com/id/1310354382/vector/malaysia-flag-button-3d-illustration-with-clipping-path.jpg?s=612x612&w=0&k=20&c=K_4bDvvmO4pjzZmVhfpBPRoTA7hjTb9ZHCa5-EVrMFk=",
    VN: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRTttOTb9s83eznZoqguG-Nk-8osKlVrx40ZQ&s",
    ID: "https://static.vecteezy.com/system/resources/previews/015/272/227/non_2x/indonesia-3d-rounded-flag-with-transparent-background-free-png.png",
    PH: "https://media.istockphoto.com/id/1042611474/vector/philippines-round-flag-vector-glossy-icon.jpg?s=612x612&w=0&k=20&c=VBPnZUVplRo9n1yiyFrzrFCGyGhj22vNuhTG-sh9nNY="
  };

  const handleFileChange = (event, projectId) => {
    const files = { ...selectedFiles };
    files[projectId] = event.target.files[0];
    setSelectedFiles(files);

    const status = { ...uploadStatus };
    status[projectId] = '';
    setUploadStatus(status);
  };

  const handleUpload = async (projectId) => {
    if (!selectedFiles[projectId]) {
      const status = { ...uploadStatus };
      status[projectId] = 'Please select a file first.';
      setUploadStatus(status);
      return;
    }

    setUploading({ ...uploading, [projectId]: true });

    const status = { ...uploadStatus };
    status[projectId] = 'Uploading...';
    setUploadStatus(status);
    // Change 'const' to 'let'
    let apicall = "";

    if (projectId == 1) {
      apicall = `${config.API_BASE_URL}/upload`;
    } else {
      apicall = `${config.API_BASE_URL}/ecoupload`;
    }
    console.log(apicall);
    const formData = new FormData();
    formData.append('file', selectedFiles[projectId]);
    formData.append('projectId', projectId);



    try {
      const response = await fetch(`${apicall}`, {
        method: 'POST',
        body: formData,
      });

      const result = await response.json();

      const newStatus = { ...uploadStatus };
      if (response.ok) {
        newStatus[projectId] = 'Upload successful! ' + result.message;
      } else {
        newStatus[projectId] = 'Upload failed: ' + result.error;
      }
      setUploadStatus(newStatus);
    } catch (error) {
      const newStatus = { ...uploadStatus };
      newStatus[projectId] = 'Upload error: ' + error.message;
      setUploadStatus(newStatus);
    } finally {
      setUploading({ ...uploading, [projectId]: false });
    }
  };

  const handleButtonClick = (action, project) => {
    console.log(`${action} clicked for ${project.name}`);
    // You can implement specific functionality for each button here
    if (action === 'View Dashboard') {
      onProjectSelect(project);
    }
    if (action === 'Grab Topline') {
      onProjectSelect(project, 'grabtopline');
    }
  };

  return (
    <div className="home-container">
      <Navbar onNavigation={onNavigation} />

      <div className="home-content">
        <h2>Select a Project</h2>
        <div className="projects-grid">
          {PROJECTS.map(project => (
            <div
              key={project.id}
              className="project-card"
            >
              <h3>{project.name}</h3>
              <p>{project.description}</p>
              <div className="countries">
                {project.countries.map(country => (
                  <div key={country} className="country-image-container" title={country}>
                    <img
                      src={countryImages[country]}
                      alt={country}
                      className="country-image"
                      onError={(e) => {
                        // Fallback to flag emoji if image fails to load
                        e.target.style.display = 'none';
                        e.target.nextSibling.style.display = 'flex';
                      }}
                    />
                    <span className="country-fallback" style={{ display: 'none' }}>
                      {countryFlags[country]}
                    </span>
                  </div>
                ))}
              </div>

              {/* Upload section for all projects */}
              {username === "1" &&
                <div className="upload-section">
                  <h4>Upload Excel Data</h4>
                  <input
                    type="file"
                    accept=".xlsx,.xls"
                    onChange={(e) => handleFileChange(e, project.id)}
                    disabled={uploading[project.id]}
                  />
                  <button
                    onClick={() => handleUpload(project.id)}
                    disabled={uploading[project.id] || !selectedFiles[project.id]}
                    className="upload-btn"
                  >
                    {uploading[project.id] ? 'Uploading...' : 'Upload'}
                  </button>
                  {uploadStatus[project.id] && <p className="upload-status">{uploadStatus[project.id]}</p>}
                </div>
              }
              <div className="action-buttons">
                <button
                  className="action-btn view-dashboard-btn"
                  onClick={() => {
                    handleButtonClick('View Dashboard', project);
                    setProjectno(project.id);
                  }
                  }
                >
                  View Dashboard
                </button>
                <button
                  className="action-btn trended-dashboard-btn"
                  onClick={() => {
                    handleButtonClick('Trended Dashboard', project);
                    setProjectno(project.id);
                  }
                  }
                >
                  Trended Dashboard
                </button>
                {project.id && project.id != '2' && <button
                  className="action-btn grab-topline-btn"
                  onClick={() => {
                    handleButtonClick('Grab Topline', project);
                    setProjectno(project.id);
                  }
                  }
                >
                  Grab Topline
                </button>}
              </div>

            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Home;